import React from 'react';
import { Search, Bell } from 'lucide-react';

/**
 * Fixed mobile top bar (52px): logo left, search + bell (with badge) right.
 * White, single bottom border. Controlled by the shell.
 */
export const MobileTopBar = ({ onSearch, onBell, badge = 0 }) => (
  <header
    data-testid="m-topbar"
    className="fixed top-0 inset-x-0 z-40 h-[52px] bg-white border-b border-[#E5E7EB] flex items-center justify-between px-4"
  >
    <img
      src="/api/uploads/travcations-logo.png"
      alt="Travcations"
      className="h-7 w-auto"
      onError={(e) => { e.target.style.display = 'none'; }}
    />
    <div className="flex items-center gap-1">
      <button
        type="button"
        onClick={onSearch}
        data-testid="m-search-btn"
        aria-label="Search"
        className="w-11 h-11 flex items-center justify-center text-[#111827] active:text-[#0F6E56]"
      >
        <Search className="h-[22px] w-[22px]" />
      </button>
      <button
        type="button"
        onClick={onBell}
        data-testid="m-bell-btn"
        aria-label="Notifications"
        className="relative w-11 h-11 flex items-center justify-center text-[#111827] active:text-[#0F6E56]"
      >
        <Bell className="h-[22px] w-[22px]" />
        {badge > 0 && (
          <span
            data-testid="m-bell-badge"
            className="absolute top-1.5 right-1.5 min-w-[16px] h-4 px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center"
          >
            {badge > 9 ? '9+' : badge}
          </span>
        )}
      </button>
    </div>
  </header>
);

export default MobileTopBar;
